export const Images = [
    "Airplane.png",
    "Alpine.png",
    "Covidtool.svg",
    "Ethan.jpg",
    "EthanPerry.jpg",
    "Github.png",
    "HCI.png",
    "Imd.svg",
    "Linkedin.png",
    "Lockheed.png",
    "Microsoft.png",
    "Mines.png",
    "Pecs.jpg",
    "Q2.svg",
    "Website.svg"
];

export const MainBanner = {
    title: "Ethan Perry",
    details: [
        "Undergrad — Colorado School of Mines.",
        "Research Intern — Microsoft Quantum."
    ],
    image: "EthanPerry.jpg",
};

export const NavItems = [
    "About",
    "Education",
    "Experience",
    "Research",
    "Projects",
    "Contact"
];

export const AboutTitle = "About Me";

export const About = {
    Content: [
        `Hello, and welcome to my website! My name is Ethan Perry, and I am a computer science undergrad from Colorado School 
        of Mines. Curious, driven, and passionate are three words which describe me best.`,
        `In my free time, I love to hike, bicycle, go camping, go backpacking, or do just about anything else outdoors. 
        I am an active member of the Club Triathlon Team at Mines and do several triathlons across the country with the team 
        each semester. In addition, I love playing and listening to music—I try to play or compose whenever I can.`,
        `Of course, I am all things computer science—not only coding, but learning and investigating new technologies, 
        research, and projects that are continually bombarding the public.`,
    ],
    Image: "Ethan.jpg",
};

export const EducationTitle = "Education";

export const Education = {
    Section: "Education",
    Title: "Colorado School of Mines",
    Subtitle: "Anticipated Graduation - 2021",
    Position: "B.S. Computer Science",
    Content: [
        "GPA: 4.0/4.0",
        "Applicable Coursework: Data structures, Linux OS, Discrete Math, Software Engineering, Computer Organization, Database Management.",
        "Independent Studies: Interactive Media Display, Motion Tracking Cameras for HCI, IOT Systems for Smart Buildings, Ethics of Computer Consciousness.",
        "TA Positions: Intro to Computer Science (CSCI 101), Data Structures (CSCI 262), Database Management (CSCI 403).",
        "Activities: Association of Computational Machinery, Linux Users Group, Club triathlon, Residence Life Ambassadors, Orchestra, Marching Band.",
        "Leadership: Secretary of Club Triathlon, UCLIMB Mentor (Undergrad CS Mentor)."
    ],
    Image: "Mines.png"
};

export const ExperienceTitle = "Experience";

export const Resume = [{
    Title: "Microsoft Quantum",
    Subtitle: "Summer 2020",
    Position: "Software Engineering Intern",
    Content: [
        "Developed a variety of new and experimental features for the front-end of the Microsoft Azure Quantum Portal.",
        "Constructed engaging data visualizations and tool sets to enhance customer experience.",
        "Cultivated a generous set of skills with front-end development, user interfaces, and user experience.",
        "Had the opportunity to design, implement, and release my own ideas.",
        "Made real business impact for Microsoft by releasing several new features to production."
    ],
    Tags: [
        "TypeScript",
        "KnockoutJS",
        ".Net",
        "Agile"
    ],
    Image: "Microsoft.png"
},
{
    Title: "Lockheed Martin",
    Subtitle: "July 2019 - May 2020",
    Position: "Software Engineering Intern",
    Content: [
        "Developed internal software and tools, ranging from web-based applications to simulations.",
        "Helped interview and hire five new interns.",
        "Learned C# and Unity to develop VR simulations to enhance customer experience."
    ],
    Tags: [
        "Angular 8",
        "Raspberry Pi",
        "Unity",
        "C#"
    ],
    Image: "Lockheed.png"
},
{
    Title: "Alpine Coffee Co",
    Subtitle: "December 2014 - May 2020",
    Position: "Software and Web Developer",
    Content: [
        "Managed the main company server and email services.",
        "Overhauled the company website, adding a retail store and enhancing SEO.",
        "Deployed several custom IOT and automation solutions, speeding up manufacturing and packaging of coffee.",
    ],
    Tags: [
        "Raspberry Pi",
        "Arduino",
        "Python",
        "Flask"
    ],
    Image: "Alpine.png"
}];

export const ReseachTitle = "Research";

export const Research = [{
    Title: "The Influence of Social Embarrassment on Engagement with Publicly Displayed Digital Content",
    Subtitle: "Accepted June 2020",
    Position: "Co-First Author",
    Content: [
        "Accepted for publishing in Springer CCIS Proceedings.",
        "Work is focused on an experiment for exploring the effetiveness of different content-sensitive solicitation strategies with public digital signage."
    ],
    Tags: [
        "HCI",
        "Computer Vision",
        "VueJS",
        "Flask"
    ],
    Image: "HCI.png"
},{
        Title: "Relay Node Placement for IOT Networks with Imperfect Communication Ranges",
        Subtitle: "January 2020 - Current",
        Position: "Chief Investigator",
        Content: [
            "Focused on development of a novel relay node placement algorithm for practical settings.",
            "Funded by the Pervasive Computing Systems group (PeCS)."
        ],
        Tags: [
            "Arduino",
            "Raspberry Pi",
            "Wireless Mesh Networks",
            "NRF Radios"
        ],
        Image: "Pecs.jpg"
},{
    Title: "Quality-aware Audio Multicast in Low Power Wireless Network",
    Subtitle: "August 2019 - January 2020",
    Position: "Associate Investigator",
    Content: [
        "An NSF funded project devoted to the application of low power, low bandwidth devices to emergency situations.",
        "My role focused on swarming robotics to test a novel multicast routing protocol.",
        "Preliminary work published in Reuleaux, the Mines undergraduate research journal."
    ],
    Tags: [
        "Swarming Robotics",
        "Wireless Mesh Networks",
        "Zigbee Radios"
    ],
    Image: "Pecs.jpg"
}];

export const ProjectsTitle = "Notable Projects";

export const Projects = [{
    Title: "Welcome to Mines!",
    Content: [
        "An interactive web application built for campus and community members around School of Mines.",
        "Funded by a 2018 Mines technology grant, the application runs on two 65\" touch screen displays: one in the student center, and the other in the main academic building on campus.",
        "The web application features a campus map, where users may search for academic buildings, resturants, and other amenities around campus.",
        "Additionally, the app contains an interactive 'self-care' wheel and series of info-tabs on food security as an on-campus initiative to promote mental-health.",
        "Lastly, a depth sensing camera and separate motion sensing camera give interactive features to the display through a subsidiary Python server."
    ],
    Image: "Imd.svg",
    Tags: [
        "VueJS",
        "NodeJS",
        "ExpressJS",
        "Computer Vision",
        "HCI"
    ],
},{
    Title: "This Website",
    Content: [
        "After having recently discovered a new web-framework called Svelte, I was highly interested in giving it a try on a bigger project.",
        "I redesigned this online portfolio in the framework, and have begun using it for most new projects since.",
        "Some of my favorite features are its template syntax and its transition/animation support."
    ],
    Image: "Website.svg",
    Tags: [
        "Svelte",
        "CSS Animations",
    ],
},{
    Title: "Q2: Quality Control v2",
    Content: [
        "A custom IOT and automation solution built for Alpine Coffee Co. The machine counts packaged coffee while it comes off of the conveyor, individually packing a custom number of cups in each box.",
        "There is also built in functionality for viewing each package with a camera and checking for consistancy.",
        "The whole mechanism, conyevor, sensors, and other functionality of the machine can be controlled and viewed from a web application hosted on-board. It will also track and display custom metrics as coffee is measured and boxed.",
    ],
    Image: "Q2.svg",
    Tags: [
        "Flask",
        "Python",
        "IOT",
        "C++ & Embedded C",
        "AJAX"
    ],
},{
    Title: "Covid Search Tool",
    Content: [
        "A flask web application designed as an SQL project.",
        "Database allows for bulk loading huge datasets which may all be retrieved through an easy and user friendly UI.",
        "Support for country wide, state wide, and county wide graphs reporting cases and other metrics.",
    ],
    Image: "Covidtool.svg",
    Tags: [
        "PSQL",
        "Flask",
        "Bulk Loading",
    ],
}];

export const Contact = [{
    Image: "Linkedin.png",
    Text: "linkedin.com/in/ethanlperry/",
    Link: "https://www.linkedin.com/in/ethanlperry/"
},{
    Image: "Airplane.png",
    Text: "Eperry1@mymail.mines.edu",
    Link: "Mailto: Eperry1@mymail.mines.edu"
},{
    Image: "Github.png",
    Text: "Ethanperry247",
    Link: "https://github.com/Ethanperry247"
}];

export const Footer = "Copywright 2020 - Ethan Perry";